export type DeliveryDestination = keyof typeof DeliveryDestinations;

export const DeliveryDestinations = {
  FR: {
    name: 'France',
    code: 'FR',
    flag: '🇫🇷',
  },
  BE: {
    name: 'Belgium',
    code: 'BE',
    flag: '🇧🇪',
  },
  NL: {
    name: 'Netherlands',
    code: 'NL',
    flag: '🇳🇱',
  },
  DE: {
    name: 'Germany',
    code: 'DE',
    flag: '🇩🇪',
  },
  IT: {
    name: 'Italy',
    code: 'IT',
    flag: '🇮🇹',
  },
  ES: {
    name: 'Spain',
    code: 'ES',
    flag: '🇪🇸',
  },
  PT: {
    name: 'Portugal',
    code: 'PT',
    flag: '🇵🇹',
  },
  IE: {
    name: 'Ireland',
    code: 'IE',
    flag: '🇮🇪',
  },
  AT: {
    name: 'Austria',
    code: 'AT',
    flag: '🇦🇹',
  },
} as const;

export type DeliveryDestinationCode = keyof typeof DeliveryDestinations;

export const deliveryDestinationsCodes = Object.values(DeliveryDestinations).map((destination) => destination.code);